import request from 'utils/request'
import {format} from 'utils'
import api from 'common/api/public'

export async function wWorkAgents() {
    return request(api.wWorkAgents.url)
}

export async function task(payload) {
    return request(format(api.task.url, {id: payload.taskId}))
}

export async function usersActions(payload = {}) {
    return request(
        api.usersActions.url,
        {
            method: api.usersActions.type,
            body: payload.body,
        },
        {
            resErrorShow() {},
            errorShow: false,
        },
    )
}
